import { EException } from 'types/response-code/salary';

export const salaryErrorMessageInfo: Record<EException, string> = {
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
